class Darkmode {
  constructor() {
    if (!this.isDarkmodeKeyInLocalStorage()) {
      if (this.userPrefersDarkmode()) {
        this.enableDarkmode();
      }
    } else {
      if (this.isDarkmodeInLocalStorageEnabled()) {
        this.enableDarkmode();
      }

      if (this.isDarkmodeInLocalStorageDisabled()) {
        this.disableDarkmode();
      }
    }

    this.initToggle();
  }

  isDarkmodeKeyInLocalStorage() {
    return localStorage.getItem("klarnachrichten-darkmode") !== null;
  }

  isDarkmodeInLocalStorageEnabled() {
    return localStorage.getItem("klarnachrichten-darkmode") === "true";
  }

  isDarkmodeInLocalStorageDisabled() {
    return localStorage.getItem("klarnachrichten-darkmode") === "false";
  }

  userPrefersDarkmode() {
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  }

  initToggle() {
    const toggle = document.querySelector("#darkmode-toggle");

    toggle.addEventListener("click", () => {
      this.toggleDarkmode();
      window.klarnachrichten.trackMatomoEvent(
        "change-dark-mode",
        document.documentElement.classList.contains("dark") ? "enable" : "disable"
      );
    });
  }

  enableDarkmode() {
    document.documentElement.classList.add("dark");
    localStorage.setItem("klarnachrichten-darkmode", "true");
  }

  disableDarkmode() {
    document.documentElement.classList.remove("dark");
    localStorage.setItem("klarnachrichten-darkmode", "false");
  }

  toggleDarkmode() {
    if (document.documentElement.classList.contains("dark")) {
      this.disableDarkmode();
      return;
    }

    this.enableDarkmode();
  }
}

window.klarnachrichten.darkmode = new Darkmode();
